import { withViewComponent } from '@updater-local/custom-element-v1';
import '@updater-components/phone-formatter';
import styles from './index.css';

export default class CompanyContactCard extends withViewComponent(styles)() {
  static props = ['value'];

  updated({ value: { phone, email } }) {
    const href = `mailto:${email}`;
    // prettier-ignore
    this.render`
      <div class="container">
        <slot></slot>
        <div>
          <div class="label">Phone</div>
          <upd-phone-formatter class="value" value="${phone}"></upd-phone-formatter>
        </div>
        <div>
          <div class="label">Email</div>
          <div class="value"><a href="${href}" target="_blank">${email}</a></div>
        </div>
      </div>
    `;
  }
}

customElements.define('upd-moveiq-company-contact-card', CompanyContactCard);
